import { SizeCategoryEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { PackingMethod } from "../packing-mathods/packing-methods.entity";
import { UnitCodes } from "../unit-codes/unit-codes.entity";
import { Uoms } from "../uoms/uom.entity";

@Entity('pallet_capacity')
export class PalletCapacity {

  @PrimaryGeneratedColumn("increment",{name:'pallet_capacity_id'})
  palletCapacityId:number;
 
  
    @Column("int",{
      nullable:false,
      name:"pallet_capacity"
      })
      palletCapacity:number;

    // @Column("int",{
    //   nullable:false,
    //   name:"packing_style"
    //   })
    // packingStyle:number;

    // @Column("int",{
    //   nullable:false,
    //   name:"unit_id"
    //   })
    // unitId:number;

    @Column("enum",{
      name:"size_category",
      enum:SizeCategoryEnum
      })
    sizeCategory:SizeCategoryEnum;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;
  
 

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user",
    length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @ManyToOne(type => PackingMethod, packinMethod => packinMethod.palletCapacityInfo, { nullable: false, })
  @JoinColumn({ name: "packing_method_id" })
  packingMethodInfo: PackingMethod;

  @ManyToOne(type => UnitCodes, unitCode => unitCode.palletCapacity)
  @JoinColumn({name:'unit_code_id'})
  unitCodeInfo: UnitCodes
 

}
